module.exports = __webpack_public_path__ + "static/statistics-723bc31854f5de4822eae7c8fd3376a2.jpg";